/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateStockupsRequestStockupsInner } from './UpdateStockupsRequestStockupsInner';
import {
    UpdateStockupsRequestStockupsInnerFromJSON,
    UpdateStockupsRequestStockupsInnerFromJSONTyped,
    UpdateStockupsRequestStockupsInnerToJSON,
} from './UpdateStockupsRequestStockupsInner';

/**
 * 
 * @export
 * @interface UpdateStockupsRequest
 */
export interface UpdateStockupsRequest {
    /**
     * 
     * @type {Array<UpdateStockupsRequestStockupsInner>}
     * @memberof UpdateStockupsRequest
     */
    stockups: Array<UpdateStockupsRequestStockupsInner>;
}

/**
 * Check if a given object implements the UpdateStockupsRequest interface.
 */
export function instanceOfUpdateStockupsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stockups" in value;

    return isInstance;
}

export function UpdateStockupsRequestFromJSON(json: any): UpdateStockupsRequest {
    return UpdateStockupsRequestFromJSONTyped(json, false);
}

export function UpdateStockupsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStockupsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockups': ((json['stockups'] as Array<any>).map(UpdateStockupsRequestStockupsInnerFromJSON)),
    };
}

export function UpdateStockupsRequestToJSON(value?: UpdateStockupsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stockups': ((value.stockups as Array<any>).map(UpdateStockupsRequestStockupsInnerToJSON)),
    };
}

